"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    highlightPalettes: ()=>highlightPalettes,
    highlightVariants: ()=>highlightVariants,
    highlightEmphases: ()=>highlightEmphases
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const highlightVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        highlightSlot: 'w-fit rounded-[0.25em] antialiased',
        childrenSlot: 'box-decoration-clone transition'
    },
    variants: {
        palette: {
            neutral: {},
            benefit: {},
            urgency: {},
            caution: {}
        },
        emphasis: {
            regular: '',
            medium: '',
            bold: ''
        }
    },
    compoundVariants: [
        {
            palette: 'neutral',
            emphasis: 'medium',
            class: {
                highlightSlot: 'bg-neutral-3 shadow-[0.16em_0_0_var(--color-neutral-3),-0.16em_0_0_var(--color-neutral-3)]',
                childrenSlot: 'text-neutral-11'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'medium',
            class: {
                highlightSlot: 'bg-benefit-3 shadow-[0.16em_0_0_var(--color-benefit-3),-0.16em_0_0_var(--color-benefit-3)]',
                childrenSlot: 'text-benefit-11'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'medium',
            class: {
                highlightSlot: 'bg-urgency-3 shadow-[0.16em_0_0_var(--color-urgency-3),-0.16em_0_0_var(--color-urgency-3)]',
                childrenSlot: 'text-urgency-11'
            }
        },
        {
            palette: 'caution',
            emphasis: 'medium',
            class: {
                highlightSlot: 'bg-caution-3 shadow-[0.16em_0_0_var(--color-caution-3),-0.16em_0_0_var(--color-caution-3)]',
                childrenSlot: 'text-caution-11'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'regular',
            class: {
                highlightSlot: 'bg-neutral-1 shadow-[0.16em_0_0_var(--color-neutral-1),-0.16em_0_0_var(--color-neutral-1)]',
                childrenSlot: 'text-neutral-11'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'regular',
            class: {
                highlightSlot: 'bg-benefit-1 shadow-[0.16em_0_0_var(--color-benefit-1),-0.16em_0_0_var(--color-benefit-1)]',
                childrenSlot: 'text-benefit-11'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'regular',
            class: {
                highlightSlot: 'bg-urgency-1 shadow-[0.16em_0_0_var(--color-urgency-1),-0.16em_0_0_var(--color-urgency-1)]',
                childrenSlot: 'text-urgency-11'
            }
        },
        {
            palette: 'caution',
            emphasis: 'regular',
            class: {
                highlightSlot: 'bg-caution-1 shadow-[0.16em_0_0_var(--color-caution-1),-0.16em_0_0_var(--color-caution-1)]',
                childrenSlot: 'text-caution-11'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'bold',
            class: {
                highlightSlot: 'bg-neutral-8 shadow-[0.16em_0_0_var(--color-neutral-8),-0.16em_0_0_var(--color-neutral-8)]',
                childrenSlot: 'text-neutral-1'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'bold',
            class: {
                highlightSlot: 'bg-benefit-8 shadow-[0.16em_0_0_var(--color-benefit-8),-0.16em_0_0_var(--color-benefit-8)]',
                childrenSlot: 'text-benefit-1'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'bold',
            class: {
                highlightSlot: 'bg-urgency-8 shadow-[0.16em_0_0_var(--color-urgency-8),-0.16em_0_0_var(--color-urgency-8)]',
                childrenSlot: 'text-urgency-1'
            }
        },
        {
            palette: 'caution',
            emphasis: 'bold',
            class: {
                highlightSlot: 'bg-caution-7 shadow-[0.16em_0_0_var(--color-caution-7),-0.16em_0_0_var(--color-caution-7)]',
                childrenSlot: 'text-caution-11'
            }
        }
    ],
    defaultVariants: {
        palette: 'neutral',
        emphasis: 'medium'
    }
});
const highlightPalettes = Object.keys(highlightVariants.variants.palette);
const highlightEmphases = Object.keys(highlightVariants.variants.emphasis);
exports.highlightEmphases = __webpack_exports__.highlightEmphases;
exports.highlightPalettes = __webpack_exports__.highlightPalettes;
exports.highlightVariants = __webpack_exports__.highlightVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "highlightEmphases",
    "highlightPalettes",
    "highlightVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
